/**
 * Partners marquee: pause on hover/focus (CSS handles prefers-reduced-motion).
 */
(function ($) {
  function bindPartnersMarquee(root) {
    const $scope = root && root.nodeType === 1 ? $(root) : $(document);

    $scope.find(".partners-slider__viewport").each(function () {
      const $vp = $(this);
      const $track = $vp.find(".partners-slider__track");
      if (!$track.length) {
        return;
      }

      $vp
        .off("mouseenter.partnersMarquee mouseleave.partnersMarquee")
        .on("mouseenter.partnersMarquee", function () {
          $track.css("animation-play-state", "paused");
        })
        .on("mouseleave.partnersMarquee", function () {
          $track.css("animation-play-state", "");
        });

      $vp
        .find(".partners-slider__link")
        .off("focus.partnersMarquee blur.partnersMarquee")
        .on("focus.partnersMarquee", function () {
          $track.css("animation-play-state", "paused");
        })
        .on("blur.partnersMarquee", function () {
          if ($vp.find(".partners-slider__link:focus").length === 0) {
            $track.css("animation-play-state", "");
          }
        });
    });
  }

  function initPartnersMarquee(root) {
    bindPartnersMarquee(root || document);
  }

  if (typeof wp !== "undefined" && wp.domReady) {
    wp.domReady(function () {
      initPartnersMarquee(document);
    });
  } else {
    $(function () {
      initPartnersMarquee(document);
    });
  }

  if (typeof acf !== "undefined" && typeof acf.addAction === "function") {
    acf.addAction("render_block_preview/type=partners-slider", function ($block) {
      const el = $block && $block[0] ? $block[0] : null;
      initPartnersMarquee(el || document);
    });
  }
})(jQuery);
